import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import util from './util';
import service from '@services/videoService';
/**
 * 视频礼物Preloader
 */
var Preloader = {
  _stickerListUrl: '/giftV2H5/giftStickers?h5=1',
  _stickerList: '',
  _stickerListPending: false,
  _stickerListResolvers: [],
  getGiftForId: function getGiftForId(giftId) {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var format, _iterator, _step, resource;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            format = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 'video';
            if (!(format === 'lottie')) {
              _context.next = 3;
              break;
            }
            throw new Error('lottie format does not supported.');
          case 3:
            if (!_this._stickerList && !_this._stickerListPending) {
              _this.updateStickerList();
            }
            if (!_this._stickerListPending) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", new Promise(function (selfResolve, selfReject) {
              var currentResolve = function currentResolve() {
                selfResolve(_this.getGiftForId(giftId, format));
              };
              _this._stickerListResolvers.push({
                resolve: currentResolve,
                reject: selfReject
              });
            }));
          case 6:
            _iterator = _createForOfIteratorHelper(_this._stickerList);
            _context.prev = 7;
            _iterator.s();
          case 9:
            if ((_step = _iterator.n()).done) {
              _context.next = 15;
              break;
            }
            resource = _step.value;
            if (!(+resource.gift_id === giftId)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", _this.getGiftForResource(resource, format));
          case 13:
            _context.next = 9;
            break;
          case 15:
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](7);
            _iterator.e(_context.t0);
          case 20:
            _context.prev = 20;
            _iterator.f();
            return _context.finish(20);
          case 23:
            return _context.abrupt("return", _this.getGiftForResource(null));
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 17, 20, 23]]);
    }))();
  },
  getGiftForResource: function getGiftForResource(resource) {
    var _arguments2 = arguments,
      _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var format, url;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            format = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : 'video';
            if (!(format === 'lottie')) {
              _context2.next = 3;
              break;
            }
            throw new Error('lottie format does not supported.');
          case 3:
            if (resource) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", {
              msg: 'null'
            });
          case 5:
            if (!(format === 'video')) {
              _context2.next = 8;
              break;
            }
            url = _this2.getUrlProxy(util.forceHttps(resource.mobile_web_url));
            return _context2.abrupt("return", {
              msg: url ? 'url' : 'null',
              data: {
                id: resource.gift_id,
                blob: url,
                json: ''
              }
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  getUrlProxy: function getUrlProxy(url) {
    // if (location.hostname === 'localhost' ||
    //     location.hostname === '[::1]' ||
    //     location.hostname.match(/^(?:\d+\.){3}(?:\d+)$/)) {
    //     return url;
    // }
    // url = url.replace('s3.amazonaws.com', `${location.host}/livemegiftproxy`);
    return url;
  },
  updateStickerList: function updateStickerList() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var APILiveroom, _iterator2, _step2, resolver, _iterator3, _step3, _resolver;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this3._stickerListPending = true;
            _context3.prev = 1;
            APILiveroom = service.createApi();
            _context3.next = 5;
            return APILiveroom.giftStickers();
          case 5:
            _this3._stickerList = _context3.sent;
            // // 资源id是361，资源id是652
            // let list=[];
            // for(let i=0;i<this._stickerList.length;i++){
            //     if(this._stickerList[i].res_id=='361'){
            //         let item={extra:this._stickerList[i].extra.split(':')[0],gift_id:this._stickerList[i].gift_id,res_id:this._stickerList[i].res_id,mobile_web_url:this._stickerList[i].mobile_web_url};
            //         list.push(item);
            //     }
            // }
            //  console.log('list-------',JSON.stringify(list));

            _this3._stickerListPending = false;
            _iterator2 = _createForOfIteratorHelper(_this3._stickerListResolvers);
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                resolver = _step2.value;
                resolver.resolve();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            _context3.next = 16;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            _this3._stickerListPending = false;
            _iterator3 = _createForOfIteratorHelper(_this3._stickerListResolvers);
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _resolver = _step3.value;
                _resolver.reject(_context3.t0);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 11]]);
    }))();
  }
};
export default Preloader;